import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wraper" }
const _hoisted_2 = { class: "home" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "aixin" }),
  /*#__PURE__*/_createElementVNode("p", { class: "title" }),
  /*#__PURE__*/_createElementVNode("p", { class: "sun" })
], -1)
const _hoisted_4 = {
  class: "main",
  ref: "about"
}
const _hoisted_5 = { class: "nav" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "icon" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "ABOUT US", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "SOLUTIONS", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "ADVERTISERS", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "PUBLISHER", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "GLOBAL COVERAGE", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "ALLIES", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "talk" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wahtapp" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createTextVNode(" Let`s Talking ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "user" })
], -1)
const _hoisted_20 = { class: "moudle" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "bottom-logo" }, [
  /*#__PURE__*/_createElementVNode("p")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_moudle1 = _resolveComponent("moudle1")!
  const _component_moudle2 = _resolveComponent("moudle2")!
  const _component_moudle3 = _resolveComponent("moudle3")!
  const _component_moudle4 = _resolveComponent("moudle4")!
  const _component_moudle4_1 = _resolveComponent("moudle4_1")!
  const _component_moudle5 = _resolveComponent("moudle5")!
  const _component_moudle6 = _resolveComponent("moudle6")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.checkTitle === 1 ? 'nav-name nav-name-ok' : 'nav-name' ),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moudleClickHandle('about')))
          }, _hoisted_8, 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.checkTitle === 2 ? 'nav-name nav-name-ok' : 'nav-name' ),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moudleClickHandle('soltuions')))
          }, _hoisted_10, 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.checkTitle === 3 ? 'nav-name nav-name-ok' : 'nav-name' ),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moudleClickHandle('advertisers')))
          }, _hoisted_12, 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.checkTitle === 4 ? 'nav-name nav-name-ok' : 'nav-name' ),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moudleClickHandle('publisher')))
          }, _hoisted_14, 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.checkTitle === 5 ? 'nav-name nav-name-ok' : 'nav-name' ),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moudleClickHandle('global')))
          }, _hoisted_16, 2),
          _createElementVNode("p", {
            class: _normalizeClass(_ctx.checkTitle === 6 ? 'nav-name nav-name-ok' : 'nav-name' ),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.moudleClickHandle('allies')))
          }, _hoisted_18, 2),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_moudle1),
          _createVNode(_component_moudle2),
          _createVNode(_component_moudle3),
          _createVNode(_component_moudle4),
          _createVNode(_component_moudle4_1),
          _createVNode(_component_moudle5),
          _createVNode(_component_moudle6)
        ])
      ], 512),
      _hoisted_21
    ])
  ]))
}